import { Suggestion, GroupedSuggestions, LocationSuggestionsParams } from '@borg/types';
import { deduplicateSuggestionsByName, DeduplicatedSuggestion } from '@borg/utils';

class LocationsService {
  search = async (query: string) => {
    const result = await serviceHttpGetFactory<Suggestion[]>('/locations', { search: query });

    if (result.isSuccess) {
      const deduplicated = deduplicateSuggestionsByName(result.data);
      return {
        ...result,
        data: deduplicated as DeduplicatedSuggestion<Suggestion>[]
      };
    }

    return result;
  };

  getSuggestions = (params?: LocationSuggestionsParams) =>
    serviceHttpGetFactory<GroupedSuggestions>('/suggestions/locations', params);
}

export const locationsService = new LocationsService();
